// app
import appRoutes from './app-routes';

const production = {
	ROUTING: appRoutes
};

export default production;
